export const cookieName = 'growthbook_id';
